// @ts-nocheck
import { FC } from "react";
import VerticalNavigation from "common/components/base/vertical-navigation";
import { ReactComponent as DocumentSetup } from "assets/media/icons/custom/documentSetup.svg";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import DescriptionOutlined from "@mui/icons-material/DescriptionOutlined";
import PeopleAltOutlined from "@mui/icons-material/PeopleAltOutlined";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import HomeIcon from "@mui/icons-material/Home";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PlagiarismOutlinedIcon from "@mui/icons-material/PlagiarismOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import {
  PiSlidersHorizontalBold,
  PiDatabaseBold,
  PiChartBarBold,
  PiChatCircleDotsBold,
  PiMagnifyingGlassBold
} from "react-icons/pi";
import IntegrationInstructionsOutlinedIcon from "@mui/icons-material/IntegrationInstructionsOutlined";
import { Tooltip } from "@mui/material";
import { useLocation, Link } from "react-router-dom";
import { Icon } from "common/components";
import { ImageCollection } from "common/config/media.config";
import { useTranslation } from "react-i18next";
import GraphicEqOutlinedIcon from "@mui/icons-material/GraphicEqOutlined";
import SearchIcon from "@mui/icons-material/Search";
import FolderOpenOutlined from "@mui/icons-material/FolderOpenOutlined";
import "./SideNav.scss";
import BackupOutlinedIcon from "@mui/icons-material/BackupOutlined";
import useAppPermission from "common/hooks/useAppPermission";
import { AnalyticsOutlined, SmartToyOutlined } from "@mui/icons-material";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import AccountTreeOutlined from "@mui/icons-material/AccountTreeOutlined";
import AltRouteOutlined from "@mui/icons-material/AltRouteOutlined";

type SideNavProps = {
  collapsed: boolean;
};
const SideNav: FC<SideNavProps> = ({ collapsed = true }) => {
  const location = useLocation();
  const { hasAdminRole } = useAppPermission();

  const { t } = useTranslation("common");
  const getClassName = (path: string) => {
    return location.pathname === path ? "active" : "inactive";
  };
  return (
    <>
      <VerticalNavigation collapse={collapsed}>
        <div className="menu">
          <div className="menu__item">
            <Tooltip title="Home" arrow placement="right">
              <Link to={"/home"}>
                <Icon
                  src={<HomeOutlinedIcon />}
                  className={getClassName("/home")}
                />
              </Link>
            </Tooltip>
          </div>

          {/* AI Search Hub */}
          <div className="menu__item">
            <Tooltip title="Engineering Search" arrow placement="right">
              <Link to={"/ai-search-hub"}>
                <Icon
                  src={<SearchIcon />}
                  className={getClassName("/ai-search-hub")}
                />
              </Link>
            </Tooltip>
          </div>

          {/* Configuration Hub */}
          {/* {hasAdminRole && (
            <div className="menu__item">
              <Tooltip title="Configuration Hub" arrow placement="right">
                <Link to={"/configure"}>
                  <Icon
                    src={<PiSlidersHorizontalBold />}
                    className={getClassName("/configure")}
                  />
                </Link>
              </Tooltip>
            </div>
          )} */}

          {/* Knowledge Graph  */}
          {hasAdminRole && (
            <div className="menu__item">
              <Tooltip title="Knowledge Library" arrow placement="right">
                <Link to={"/knowledge-library"}>
                  <Icon
                    src={<FolderOpenOutlined />}
                    className={getClassName("/knowledge-library")}
                    // isCustom={true}
                  />
                </Link>
              </Tooltip>
            </div>
          )}

          {/* Knowledge Agent  */}
          <div className="menu__item">
            <Tooltip title="Knowledge Agents" arrow placement="right">
              <Link to={"/knowledge-agent/all-details"}>
                <Icon
                  // src={<VerifiedUserOutlinedIcon />}
                  src={<SmartToyOutlined />}
                  className={getClassName("/knowledge-agent/all-details")}
                />
              </Link>
            </Tooltip>
          </div>

          {/* Processing Hub */}
          <div className="menu__item">
            <Tooltip title="Processing Hub" arrow placement="right">
              <Link to={"/processing-hub"}>
                <Icon
                  // src={<PiDatabaseBold />}
                  src={<BackupOutlinedIcon />}
                  className={getClassName("/processing-hub")}
                />
              </Link>
            </Tooltip>
          </div>

          {/* packaging  */}
          <div className="menu__item">
            <Tooltip title="Packaging" arrow placement="right">
              <Link to={"/packaging-workspace"}>
                <Icon
                  src={<Inventory2OutlinedIcon />}
                  className={getClassName("/packaging-workspace")}
                />
              </Link>
            </Tooltip>
          </div>

          {/* Ontology Studio */}
          <div className="menu__item">
            <Tooltip title="Ontology Studio" arrow placement="right">
              <Link to={"/create-ontology"}>
                <Icon
                  src={<AltRouteOutlined />}
                  className={
                    location.pathname.startsWith("/create-ontology") ||
                    location.pathname.startsWith("/ontology-studio")
                      ? "active"
                      : "inactive"
                  }
                />
              </Link>
            </Tooltip>
          </div>

          {/* Management of Change */}
          <div className="menu__item">
            <Tooltip title="Management of Change" arrow placement="right">
              <Link to={"/management-of-change"}>
                <Icon
                  src={<AccountTreeOutlined />}
                  className={
                    location.pathname.startsWith("/management-of-change")
                      ? "active"
                      : "inactive"
                  }
                />
              </Link>
            </Tooltip>
          </div>

          {/* Data Analysis Hub - Icon only, no routing */}
          {/* <div className="menu__item">
            <Tooltip title="Data Analysis Hub" arrow placement="right">
              <Link to={"/analysis"}>
                <Icon
                  src={<PiChartBarBold />}
                  className={getClassName("/analysis")}
                />
              </Link>
            </Tooltip>
          </div> */}

          {/* Chatbot Hub */}
          {/* <div className="menu__item">
            <Tooltip title="Chatbot Hub" arrow placement="right">
              <Link to={"/ai-chatbot"}>
                <Icon
                  src={<PiChatCircleDotsBold />}
                  className={getClassName("/ai-chatbot")}
                />
              </Link>
            </Tooltip>
          </div> */}

          {/* <div className="menu__item">
            <Link to={"/documents"}>
              <Icon
                src={<DescriptionOutlined />}
                className={getClassName("/documents")}
              />
            </Link>
          </div> */}

          {/* <div className="menu__item">
            <Link to={"/analysis"}>
              <Icon
                src={<AnalyticsOutlined />}
                className={getClassName("/analysis")}
              />
            </Link>
          </div> */}

          {/* {hasAdminRole && (
            <div className="menu__item">
              <Tooltip title="Document Setup" arrow placement="right">
                <Link to={"/document-setup"}>
                  <Icon
                    src={<PlagiarismOutlinedIcon />}
                    className={getClassName("/document-setup")}
                    // isCustom={true}
                  />
                </Link>
              </Tooltip>
            </div>
          )} */}

          {/* {hasAdminRole && (
            <div className="menu__item">
              <Tooltip title="Data Integration Hub" arrow placement="right">
                <Link to={"/data-integration-hub"}>
                  <Icon
                    src={<IntegrationInstructionsOutlinedIcon />}
                    className={getClassName("/data-integration-hub")}
                    // isCustom={true}
                  />
                </Link>
              </Tooltip>
            </div>
          )} */}

          {/* {hasAdminRole && (
            <div className="menu__item">
              <Tooltip title="Classification Hub" arrow placement="right">
                <Link to={"/classification-hub"}>
                  <Icon
                    src={<LocalOfferOutlinedIcon />}
                    className={getClassName("/classification-hub")}
                    // isCustom={true}
                  />
                </Link>
              </Tooltip>
            </div>
          )} */}

          {hasAdminRole && (
            <div className="menu__item">
              <Tooltip title="Admin Config" arrow placement="right">
                <Link to={"/users"}>
                  <Icon
                    src={<PeopleAltOutlined />}
                    className={getClassName("/users")}
                  />
                </Link>
              </Tooltip>
            </div>
          )}

          {/* <div className="menu__item">
            <Link to={"/bulk-upload"}>
              <Icon
                src={<LibraryBooksIcon />}
                className={getClassName("/bulk-upload")}
                isCustom={true}
              />
            </Link>
          </div> */}
        </div>
      </VerticalNavigation>
    </>
  );
};

export default SideNav;
